export interface TargetSkillType {
  id: string;
  name: string;
}

export const TargetSkillTypeClassname: { [key: string]: string } = {
  Target: 'nc_icon-nc_target',
  Extension: 'nc_icon-nc_extension',
  Support: 'nc_icon-nc_support',
  Unit: 'nc_icon-nc_target',
  NotOnARoadmap: 'nc_icon-nc_not-on-a-map',
  'Additional Support': 'nc_icon-nc_support',
};

export enum TargetSkillTypeLabel {
  TARGET = 'Target',
  EXTENSION = 'Extension',
  SUPPORT = 'Support',
  UNIT = 'Unit',
  NOT_ON_A_ROADMAP = 'NotOnARoadmap',
  ADDITIONAL_SUPPORT = 'Additional Support',
}
